import { gql } from "@/gql/__generated__";
import { useMutation } from "@apollo/client";

const RESEND_EMAIL_VERIFICATION_MUTATION = gql(`
  mutation ResendEmailVerification($userId: ID!) {
    resendEmailVerification(userId: $userId) {
      __typename
      ... on ResendEmailVerificationSuccess { userId }
      ... on UserNotFound { id }
    }
  }
`);

export const useResendEmailVerification = () => {
  return useMutation(RESEND_EMAIL_VERIFICATION_MUTATION);
};
